import React from "react";

const cx = (...c) => c.filter(Boolean).join(" ");

export default function Input({
    label,
    hint,
    error,
    className = "",
    inputClassName = "",
    labelClassName = "",
    id,
    disabled = false,
    startIcon,
    endIcon,
    ...props
}) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const inputId = id || React.useId();

    const baseInput = [
        "block w-full rounded px-3 py-2 outline-none",
        "bg-gray-50 dark:bg-white/5",
        "border border-gray-100 dark:border-white/10",
        "text-xs font-normal text-foreground-light dark:text-foreground-dark",
        "placeholder:font-normal placeholder:text-gray-400 dark:placeholder:text-neutral-500",
        "focus:bg-white dark:focus:bg-card-dark",
        "focus:outline-none focus:ring-0 focus:border-primary",
        "transition-colors duration-150 ease-out",
    ].join(" ");

    const errorStyles = [
        "border-danger-light dark:border-danger-dark",
        "focus:ring-0",
        "focus:border-danger-light dark:focus:border-danger-dark",
    ].join(" ");

    const disabledStyles =
        "opacity-60 cursor-not-allowed bg-neutral-100 dark:bg-neutral-800";

    return (
        <label htmlFor={inputId} className={cx("block", className)}>
            {label && (
                <span className={cx("block text-xs sm:text-sm font-normal mb-1.5 text-foreground-light dark:text-foreground-dark", labelClassName)}>
                    {label}
                </span>
            )}

            <div className="relative flex items-center">
                {startIcon && (
                    <span className="absolute left-3 text-subtle-light dark:text-subtle-dark flex items-center pointer-events-none z-10">
                        {startIcon}
                    </span>
                )}
                <input
                    id={inputId}
                    disabled={disabled}
                    className={cx(
                        baseInput,
                        startIcon ? "pl-10" : "",
                        endIcon ? "pr-10" : "",
                        error ? errorStyles : "",
                        disabled ? disabledStyles : "",
                        inputClassName
                    )}
                    {...props}
                />
                {endIcon && (
                    <span className="absolute right-3 flex items-center z-10 pointer-events-none">
                        {endIcon}
                    </span>
                )}
            </div>

            {hint && !error && (
                <p className="mt-1 text-xs text-subtle-light dark:text-subtle-dark">
                    {hint}
                </p>
            )}
            {typeof error === "string" && error.length > 0 && (
                <p className="mt-1 text-xs text-danger-light dark:text-danger-dark">
                    {error}
                </p>
            )}
        </label>
    );
}